export const SCROLL_BEHAVIOR = {
  behavior: 'smooth',
  block: 'start',
};
